import { useRef, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { HostBackend } from '../../Routes/HostBackend.js';
import { GetHeaders } from '../../Components/Admin/Functions/FetchHeaders.js';
import { ScrollTop } from '../../Components/Public/Functions/ScrollTop.js';
/* document */
import { Navigation } from '../../Components/Admin/Document/Navigation.js';
import { MsgBackend } from '../../Components/Admin/Document/MsgBackend.js';
import { AuthTimer } from '../../Components/Admin/Auth/AuthTimer.js';
import { Header } from '../../Components/Admin/Document/Header.js';
import { Footer } from '../../Components/Public/Document/Footer.js';
import { BackTop } from '../../Components/Public/Document/BackTop.js';
import { Entities } from '../../Components/Admin/Collection/Entities.js';
import { Attributes } from '../../Components/Admin/Collection/Attributes.js';
import { Describes } from '../../Components/Admin/Collection/Describes.js';

export const Collection = () => {
    const { entity, sort } = useParams();
    const sorter = sort ? `/sortby?sort=${sort}` : '';
    const backend = HostBackend();
    const token = sessionStorage.getItem('token');
    const [choosers, setChoosers] = useState([]);
    const [datas, setDatas] = useState([]);
    const [msg, setMsg] = useState('');
    const clock = useRef(null);
    const [time, setTime] = useState(60 * 15);
    const authTimer = AuthTimer(clock, time, setTime);
    useEffect(() => {
        const fetchData = async () => {
            const dataChoosers = await fetch(`${backend}/admin/choosers/${entity}`, GetHeaders(token));
            const choosers = await dataChoosers.json();
            setChoosers(choosers);
            const dataCollection = await fetch(`${backend}/admin/collection/${entity}${sorter}`, GetHeaders(token));
            const datas = await dataCollection.json();
            setDatas(datas);
            if (datas.msg) setMsg({
                msg: datas.msg,
                refresh: true,
            });
            if (datas.err) setMsg({
                err: datas.err,
            });
        };
        fetchData();
        ScrollTop();
    }, [backend, entity, sorter, sort, token]);
    if (token) {
        return (
            <div className="collection">
                <Navigation entity={entity} chooser={choosers} clock={authTimer.clock} />
                <MsgBackend entity={entity} msg={msg} setMsg={setMsg} />
                <Header />
                <Entities entity={entity} datas={datas} />
                <Attributes entity={entity} datas={datas} />
                <Describes entity={entity} datas={datas} />
                <BackTop />
                <Footer />
            </div>
        )
    } else {
        return (<></>)
    }
}